module.exports = __webpack_public_path__ + "img/google.ecd17d80.png";